import { Body1Stronger, Button, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { TViewApprovalDialogState, ApprovalStatus, TApproval } from '../types';

const useStyles = makeStyles({
  approvalbutton: {
    fontWeight: tokens.fontWeightSemibold,
  },
  colorApproved: {
    color: tokens.colorBrandForeground1,
    '&:hover': {
      color: tokens.colorBrandForeground1,
    },
  },
  colorDeclined: {
    color: tokens.colorStatusDangerForeground1,
    '&:hover': {
      color: tokens.colorStatusDangerForeground1,
    },
  },
});

type TProps = {
  approval: TApproval;
  setViewApprovalDialogState?: (state: TViewApprovalDialogState) => void;
  size?: 'small' | 'medium' | 'large';
  textOnly?: boolean;
};

const ApprovalStatusButton = ({ approval, setViewApprovalDialogState, size = 'medium', textOnly }: TProps) => {
  const text = approval.status.charAt(0) + approval.status.slice(1).toLocaleLowerCase();
  const classes = useStyles();
  const className =
    approval.status === ApprovalStatus.APPROVED
      ? classes.colorApproved
      : approval.status === ApprovalStatus.DECLINED
        ? classes.colorDeclined
        : '';
  if (textOnly)
    return (
      <span className={className}>
        <Body1Stronger>{text}</Body1Stronger>
      </span>
    );
  return (
    <Button
      appearance="secondary"
      size={size}
      className={mergeClasses(className, classes.approvalbutton)}
      onClick={() => setViewApprovalDialogState?.({ isOpen: true, approvalId: approval._id })}
    >
      {text}
    </Button>
  );
};

export default ApprovalStatusButton;
